import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React, { memo, useMemo } from 'react';
import Input from '../Input';
import MenuItem from '../MenuItem';

var Select = function (props) {
  var hide = props.hide,
      rawOption = props.options,
      multiple = props.multiple,
      SelectProps = props.SelectProps,
      rest = _objectWithoutPropertiesLoose(props, ["hide", "options", "multiple", "SelectProps"]); // @ts-ignore


  var options = useMemo(function () {
    return (// @ts-ignore
      rawOption.map(function (item) {
        // @ts-ignore
        if (_typeof(item) === 'object') return item;
        return {
          id: item.toString(),
          name: item.toString()
        };
      })
    );
  }, [rawOption]);
  if (hide) return null;
  return /*#__PURE__*/React.createElement(Input, _extends({
    select: true,
    SelectProps: _extends({
      autoWidth: true,
      multiple: multiple,
      renderValue: function renderValue(value) {
        var arrValue = Array.isArray(value) ? value : [value];
        var selectedOptions = arrValue.map(function (id) {
          return options.find(function (item) {
            return item.id === id;
          });
        });
        return selectedOptions.map(function (item) {
          var _item$name;

          return (_item$name = item == null ? void 0 : item.name) != null ? _item$name : '';
        }).join(', ');
      }
    }, SelectProps)
  }, rest), options.map(function (item) {
    return /*#__PURE__*/React.createElement(MenuItem, _extends({
      key: item.id,
      value: item.id
    }, item));
  }));
};

export default /*#__PURE__*/memo(Select);